import { PageDefinition } from '@fullstory/proto/fs/api/pages';
import { NativePlatform } from '@fullstory/proto/fs/api/segment';
import { Timestamp } from '@fullstory/proto/google/protobuf';
import { AppState } from '@fullstory/redux';
import { DeepPartial } from '@fullstory/typeutils';

export const page1: PageDefinition = {
  id: 1,
  friendlyId: '1234',
  name: 'Test Page',
  description: 'test page description',
  archived: false,
  labels: [],
  patterns: [
    {
      path: [
        {
          literal: 'initial',
        },
        {
          literal: 'page',
        },
      ],
      fragment: [],
      domains: [
        {
          terms: [
            {
              wildcard: {
                double: false,
              },
            },
          ],
        },
      ],
      query: [],
    },
  ],
  isUserDefined: false,
  createdBy: 'FullStory',
  createdAt: Timestamp.fromDate(new Date('2021-05-21T06:00:29.397Z')),
  updatedBy: 'FullStory',
  updatedAt: Timestamp.fromDate(new Date('2021-06-10T06:00:27.071Z')),
  expiration: null,
  metadata: null,
  suggestion: null,
};

export const page2: PageDefinition = {
  id: 3,
  friendlyId: '12345',
  name: 'Another Test',
  description: 'test page description',
  archived: false,
  labels: [],
  patterns: [
    {
      path: [
        {
          literal: 'initial',
        },
        {
          literal: 'page2',
        },
      ],
      fragment: [],
      domains: [
        {
          terms: [
            {
              wildcard: {
                double: false,
              },
            },
          ],
        },
      ],
      query: [],
    },
  ],
  isUserDefined: false,
  createdBy: 'FullStory',
  createdAt: Timestamp.fromDate(new Date('2021-05-21T06:00:29.397Z')),
  updatedBy: 'FullStory',
  updatedAt: Timestamp.fromDate(new Date('2021-06-10T06:00:27.071Z')),
  expiration: null,
  metadata: null,
  suggestion: null,
};

const nmPage1: PageDefinition = {
  id: 4,
  friendlyId: '123456',
  name: 'iOS Test',
  description: 'test page description',
  archived: false,
  labels: [
    {
      pageName: 'iOS Test',
      platforms: [
        {
          platform: NativePlatform.NATIVE_PLATFORM_IOS,
          lastSeen: Timestamp.fromDate(new Date('2022-12-12T20:40:52.058495Z')),
        },
      ],
    },
  ],
  patterns: [],
  isUserDefined: false,
  createdBy: 'FullStory',
  createdAt: Timestamp.fromDate(new Date('2021-05-21T06:00:29.397Z')),
  updatedBy: 'FullStory',
  updatedAt: Timestamp.fromDate(new Date('2021-06-10T06:00:27.071Z')),
  expiration: null,
  metadata: null,
  suggestion: null,
};

const nmPage2: PageDefinition = {
  id: 5,
  friendlyId: '1234567',
  name: 'android Test',
  description: 'test page description',
  archived: false,
  labels: [
    {
      pageName: 'android Test',
      platforms: [
        {
          platform: NativePlatform.NATIVE_PLATFORM_ANDROID,
          lastSeen: Timestamp.fromDate(new Date('2022-12-12T20:40:52.058495Z')),
        },
      ],
    },
  ],
  patterns: [],
  isUserDefined: false,
  createdBy: 'FullStory',
  createdAt: Timestamp.fromDate(new Date('2021-05-21T06:00:29.397Z')),
  updatedBy: 'FullStory',
  updatedAt: Timestamp.fromDate(new Date('2021-06-10T06:00:27.071Z')),
  expiration: null,
  metadata: null,
  suggestion: null,
};

export const mockInitialPageState = (): DeepPartial<AppState> => {
  const data = {
    pages: new Map(),
    apiLimit: 1000,
  };
  data.pages.set(page1.id, page1);
  data.pages.set(page2.id, page2);
  return {
    pages: {
      pages: {
        lastRequested: 0,
        lastResponded: 0,
        loading: false,
        error: false,
        data,
      },
    },
  };
};

export const mockNativeMobilePageState = (): DeepPartial<AppState> => {
  const data = {
    pages: new Map(),
    apiLimit: 1000,
  };
  data.pages.set(nmPage1.id, nmPage1);
  data.pages.set(nmPage2.id, nmPage2);
  return {
    pages: {
      pages: {
        lastRequested: 0,
        lastResponded: 0,
        loading: false,
        error: false,
        data,
      },
    },
  };
};
